exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-event-labwork a{color:var(--theme-color)}.timeline-event-labwork a:hover{color:var(--theme-color-highlight)}.timeline-event-labwork__title{margin-top:15px;font-size:15px;font-weight:700}.timeline-event-labwork__subtitle{margin-top:15px;font-size:12px;font-weight:500}.timeline-event-labwork__text{font-size:14px;font-weight:500}.timeline-event-labwork__text p{margin-bottom:8px}.timeline-event-labwork__text p:last-child{margin-bottom:0}", ""]);

// exports
